webpackJsonp([160632251377204],{

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Head = __webpack_require__(17);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _contact = __webpack_require__(18);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Next - How we work' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero is-relative is-theme-secondary hero-waves' },
	      _react2.default.createElement(_Head2.default, null),
	      _react2.default.createElement(
	        'div',
	        { id: 'main-hero', className: 'hero-body ' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns is-vcentered is-tablet-portrait' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-7 header-caption has-text-left' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'landing-title' },
	                'Discover How We Deliver Your Products'
	              ),
	              _react2.default.createElement(
	                'h2',
	                { className: 'subtitle is-7 light-text' },
	                'We build client relationships on trust. We openly share all of our work methods and the rules we rely on.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'pt-10 pb-10' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#contact-form', className: 'button button-cta btn-align btn-outlined is-bold light-btn rounded z-index-2' },
	                  'Hire Us'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-9 is-offset-1 is-hidden-mobile' },
	              _react2.default.createElement('figure', { className: 'image is-4by3 reactjs-logo' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'features', className: 'section is-medium' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container has-text-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-title-wrapper has-text-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bg-number' },
	            _react2.default.createElement('i', { className: 'fas fa-cogs' })
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title-landing' },
	            'Process of work'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns is-vcentered has-text-centered' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-12' },
	              _react2.default.createElement(
	                'ol',
	                { className: 'simple-feed sprint' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'feed-item' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'is-icon-2x accent-text' },
	                    '01'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'feed-item-text content has-text-left' },
	                    _react2.default.createElement(
	                      'h2',
	                      null,
	                      'Kickoff'
	                    ),
	                    'At Next, successful kickoff means getting to the bottom of user expectations and needs before project designing and development.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'feed-item' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'is-icon-2x accent-text' },
	                    '02'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'feed-item-text content has-text-left' },
	                    _react2.default.createElement(
	                      'h2',
	                      null,
	                      'Product Development'
	                    ),
	                    'We repeat the process over and over to get your idea into the shape. We use Scrum to make our work efficient and valuable. The key elements of Scrum are:-',
	                    _react2.default.createElement('img', { className: 'sprint-image mt-30 mb-10 is-hidden-mobile', src: '/files/images/illustrations/UI/sprint.png' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'feed-item disable-dot' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'feed-item-text content has-text-left' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'container' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'content-wrapper' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'columns is-vcentered' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'column is-4' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'content content-flex' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'dark-text has-text-left' },
	                                _react2.default.createElement(
	                                  'h2',
	                                  { className: 'is-landing pt-5 pb-5' },
	                                  'Scrum Planning'
	                                ),
	                                'With you plan which features to be included in the product and then implement them. We plan work in intervals called Sprints which usually lasts 2 weeks.'
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'column is-4' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'content content-flex' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'dark-text has-text-left' },
	                                _react2.default.createElement(
	                                  'h2',
	                                  { className: 'is-landing pt-5 pb-5' },
	                                  'Scrum Implementation'
	                                ),
	                                'We divide our work into small parts so that our efforts can be seen individually in each sprint. Every sprint delivers a different piece of work.'
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'column is-4' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'content content-flex' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'dark-text has-text-left' },
	                                _react2.default.createElement(
	                                  'h2',
	                                  { className: 'is-landing pt-5 pb-5' },
	                                  'Retrospective'
	                                ),
	                                'Transparency is the thing we value the most. Every sprint we adapt to change and strive to make it better.'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'features', className: 'section section-feature-grey is-medium' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container has-text-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-title-wrapper has-text-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bg-number' },
	            '1'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title-landing' },
	            'Transparency'
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            'We guarantee transparency on every step of our way, to gain your trust.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns is-vcentered has-text-centered' },
	            _react2.default.createElement('div', { className: 'column is-hidden-mobile' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'square-icon-box is-landing secondary' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon-box-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box' },
	                    _react2.default.createElement('i', { className: 'fas fa-stopwatch' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-title' },
	                  'Time contract & Accurate time logs'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-text is-tablet-padded' },
	                  'You only pay for the amount of time our project team has worked for you and you can check the time logs anytime you need.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'square-icon-box is-landing secondary' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon-box-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box' },
	                    _react2.default.createElement('i', { className: 'far fa-edit' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-title' },
	                  'NDA on request'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-text is-tablet-padded' },
	                  'We understand that you may want to hide your ideas in all ways possible, therefore, we agree to sign NDA\'s.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'square-icon-box is-landing primary' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon-box-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box' },
	                    _react2.default.createElement('i', { className: 'fas fa-headset' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-title' },
	                  'Direct access to Development Environment'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-text is-tablet-padded' },
	                  'You can clearly see what\'s going on under the hood, anytime, to make sure everything is according to your taste and ideas.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'square-icon-box is-landing primary' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'icon-box-wrapper' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box' },
	                    _react2.default.createElement('i', { className: 'fas fa-globe-americas' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-title' },
	                  'Time zones are not a problem'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'box-text is-tablet-padded' },
	                  'You may think that time difference may create a problem, but fear not, planned sessions, weekly calls and communicative channels do the needful.'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'column is-hidden-mobile' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'features', className: 'section is-medium' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container has-text-centered' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section-title-wrapper has-text-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'bg-number' },
	            '1'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'section-title-landing' },
	            'Tools of Trade'
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            'The tools through which we communicate are based on the needs of the projects. Here ae some tools which we use frequently:-'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns is-vcentered has-text-centered' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-one-third' },
	              _react2.default.createElement(
	                'div',
	                { className: 'feature-card card-lg light-bordered hover-inset has-text-centered mb-20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-icon' },
	                  _react2.default.createElement('img', { src: '/files/images/illustrations/icons/slack.svg', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-title' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Slack'
	                  ),
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'Real communication tool'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-feature-description' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: '' },
	                    'Real communication tool for the clients and the team. Every project has a dedicated private channel to discuss their work. This way your project info is both private and transparent at the same time.'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-one-third' },
	              _react2.default.createElement(
	                'div',
	                { className: 'feature-card card-lg light-bordered hover-inset has-text-centered mb-20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-icon' },
	                  _react2.default.createElement('img', { src: '/files/images/illustrations/icons/jira.svg', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-title' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'JIRA'
	                  ),
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'Project management software'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-feature-description' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: '' },
	                    'Here you can see the current status of your project, past doings and future planings. Also, from here you can check time logs and progress in you project.'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-one-third' },
	              _react2.default.createElement(
	                'div',
	                { className: 'feature-card card-lg light-bordered hover-inset has-text-centered mb-20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-icon' },
	                  _react2.default.createElement('img', { src: '/files/images/illustrations/icons/confluence.svg', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-title' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Confluence'
	                  ),
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'Knowledge base kept in Confluence'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-feature-description' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: '' },
	                    'Here\'s where we keep plans, retrospectives, documentation and other know-how pieces for everyone to know, for the smooth running of the project.'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'columns is-vcentered has-text-centered' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-one-third is-offset-2-desktop' },
	              _react2.default.createElement(
	                'div',
	                { className: 'feature-card card-lg light-bordered hover-inset has-text-centered mb-20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-icon' },
	                  _react2.default.createElement('img', { src: '/files/images/illustrations/icons/google-suite.svg', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-title' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'G Suite'
	                  ),
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'Utilisation of tools from Google'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-feature-description' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: '' },
	                    'To share information we utilise tools from Google. The video calls are handles via Hangouts and the documents are shared via Drive- in folders with accurate accessibility for Next and its client\'s team.'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-one-third' },
	              _react2.default.createElement(
	                'div',
	                { className: 'feature-card card-lg light-bordered hover-inset has-text-centered mb-20' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-icon' },
	                  _react2.default.createElement('img', { src: '/files/images/illustrations/icons/github.svg', alt: '' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-title' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Github'
	                  ),
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'A place to share and store send code with world by developers '
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'card-feature-description' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: '' },
	                    'A global platform that enables you to collaborate and present your work instantly, no matte what platform you work on.'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_contact2.default, null)
	      )
	    )
	  );
	}
	// import Img from 'gatsby-image';
	
	
	Template.propTypes = {
	  data: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-how-we-work-jsx-f8d40a124b8ee649ce87.js